import { render } from "./HomePage.vue?vue&type=template&id=1e2e20cc&scoped=true"
const script = {}

import "./HomePage.vue?vue&type=style&index=0&id=1e2e20cc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2e20cc"]])

export default __exports__